module.exports = __webpack_public_path__ + "main/assets/fonts/scoville/scoville.ttf";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/scoville/scoville.ttf
// module id = 1281
// module chunks = 0